export default __webpack_public_path__ + "static/media/1.e4e12172.jpg";